const topButton = document.querySelector('[data-scroll-top-button]');
if (topButton && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  topButton.addEventListener(
    'click',
    (event) => {
      event.stopImmediatePropagation();
      window.scrollTo(0, 0);
    },
    true
  );
}

const footer = document.querySelector('.footer-sections, .site-footer, .footer');
if (footer) {
  const target = '/pages/faq#returns-and-exchanges';
  const returnUrl = /\/pages\/(return-policy|returns-page|returns)\b|\/policies\/refund-policy/i;
  const redirect = (link) => {
    if (link.getAttribute('href') !== target) link.setAttribute('href', target);
  };

  footer.querySelectorAll('a[href]').forEach((link) => {
    if (returnUrl.test(link.getAttribute('href') || '')) redirect(link);
  });

  footer.querySelectorAll('[class*="footer__block"]').forEach((block) => {
    const heading = block.querySelector('[class*="title"], h2, h3, h4');
    if (heading?.textContent.trim().toLowerCase() === 'support') {
      block.querySelectorAll('a[href]').forEach((link) => {
        if ((link.textContent || '').toLowerCase().includes('return')) redirect(link);
      });
    }
  });
}
